<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-26 15:45:54
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-26 16:06:41
 * @FilePath: \partner.chaoyongtuan.com\src\views\homePage\home\components\largeScreenEntrance.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="p-24 white-bg radius-8 mb-16 flex flex-align-center flex-just-between">
		<div class="yx-color-pure-1 yx-pingfang-Medium fz-18">作战中心</div>
		<div class="cursor-pointer flex-row-align-center font-h6-regular color-gy-7" @click="gotoAuth">
			<i class="i-data-screen"></i>
			<span class="ml-4">数据大屏</span>
			<i class="el-icon-arrow-right"></i>
		</div>
	</div>
</template>

<script>
export default {
	name: 'largeScreenEntrance',
	props: {
		link: {
			type: String,
			default: '',
		},
	},
	methods: {
		async gotoAuth() {
			const { link } = this;
			if (!link) return this.$message.error('尚未开通');
			window.open(link, '_blank');
		},
	},
};
</script>

<style scoped>
.app-enter {
	width: 113px;
	height: 36px;
	background: url('~@/assets/public/app-icon.png') no-repeat 50% 50%;
	position: relative;
	border-radius: 18px;
	line-height: 36px;
}
</style>
